export interface UserLoginAttemptsDetails {
	invalidLoginCount: number;
	lockoutWindowExpires?: Date;
}

export const createDefaultUserLoginAttemptsDetails = (): UserLoginAttemptsDetails => ({
	invalidLoginCount: 0
});
